import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { TaskLocationStatus } from '@ml/tasks/types/enums/task-location-status.enum';
import { TaskLocationService } from '@ml/tasks/services/task-location.service';
import { finalize } from 'rxjs/operators';
var OrderLocationStatusDialogComponent = /** @class */ (function () {
    function OrderLocationStatusDialogComponent(data, dialogRef, taskLocationService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.taskLocationService = taskLocationService;
        this.statusControl = new FormControl('', Validators.required);
        this.statuses = Object.values(TaskLocationStatus).map(function (value) { return ({
            id: value,
            name: value
        }); });
    }
    OrderLocationStatusDialogComponent.prototype.ngOnInit = function () {
        this.statusControl.setValue(this.data.taskLocation.status);
    };
    Object.defineProperty(OrderLocationStatusDialogComponent.prototype, "employeeName", {
        get: function () {
            if (this.data.task.employee) {
                return this.data.task.employee.name;
            }
        },
        enumerable: true,
        configurable: true
    });
    OrderLocationStatusDialogComponent.prototype.onClose = function () {
        this.dialogRef.close();
    };
    OrderLocationStatusDialogComponent.prototype.onSave = function () {
        var _this = this;
        this.loading = true;
        this.data.taskLocation.status = this.statusControl.value;
        this.taskLocationService
            .setStatus(this.data.taskLocation)
            .pipe(finalize(function () { return (_this.loading = false); }))
            .subscribe(function (taskLocation) {
            _this.data.taskLocation = taskLocation;
            _this.dialogRef.close(taskLocation);
        });
    };
    return OrderLocationStatusDialogComponent;
}());
export { OrderLocationStatusDialogComponent };
